export const queryKeys = {
  resources: {
    list: (resource: string, params?: Record<string, unknown>) =>
      [resource, 'list', params] as const,
    one: (resource: string, id?: number | string) => [resource, 'one', id] as const,
  },

  package: {
    packageItems: {
      byPackage: (packageId?: number) => ['package_items', 'by_package', packageId] as const,
    },
  },

  companyContacts: {
    byCompany: (companyId?: number) => ['company_contacts', 'by_company', companyId] as const,
  },

  notifications: {
    headerNotifications: () => ['notifications', 'header'] as const,
  },

  failReport: {
    failReportItems: {
      byFailReport: (failReportId?: number) =>
        ['fail_report_items', 'by_fail_report', failReportId] as const,
    },
  },
};
